__turbopack_context__.v({
  "trigger": "lD9VmW_trigger",
  "trigger__icon": "lD9VmW_trigger__icon",
  "trigger__text": "lD9VmW_trigger__text",
});
